import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { Home1Component } from "./dashboard/home1/home1.component";
import { LegalDocumentComponent } from './extrapages/legal-document/legal-document.component';
import { ExcluirDadosComponent } from './extrapages/excluir-dados/excluir-dados.component';
import { SEO } from '../core/seo/seo-paginas';

const routes: Routes = [
  {
    path: 'termos-de-uso',
    component: LegalDocumentComponent,
    data: {
      seo: SEO.termos,
      lgpdChave: 'termos',
      titulo: 'Termos de uso',
    },
  },
  {
    path: 'politica-de-privacidade',
    component: LegalDocumentComponent,
    data: {
      seo: SEO.privacidade,
      lgpdChave: 'privacidade',
      titulo: 'Política de privacidade',
    },
  },
  {
    path: 'excluir-dados',
    component: ExcluirDadosComponent,
    data: { seo: SEO.excluirDados },
  },
  {
    path: "",
    component: Home1Component,
    data: {
      title: 'Início',
      seo: SEO.home,
      heroAction: 'reservation',
      showFeaturedOffers: false,
      recentCarouselTitle: 'Razões para alugar na Velz',
      showRecentCarouselImageBadges: false,
      simpleRecentCarouselCards: true,
      fixedRecentReasonsGrid: true
    }
  },
  {
    path: "tercerizacao",
    component: Home1Component,
    data: {
      title: 'Tercerização',
      seo: SEO.tercerizacao,
      heroAction: 'reservation',
      showTercerizacaoVehicleSearch: true,
      showTercerizacaoGrowingSection: true,
      tipoLocacao: 'tercerizacao',
      showFeaturedOffers: false,
      recentCarouselTitle: 'Razões para alugar na Velz',
      showRecentCarouselImageBadges: false,
      simpleRecentCarouselCards: true,
      fixedRecentReasonsGrid: true
    }
  },
  {
    path: "assinatura",
    component: Home1Component,
    data: {
      title: 'Assinatura',
      seo: SEO.assinatura,
      heroAction: 'reservation',
      showTercerizacaoVehicleSearch: true,
      showTercerizacaoGrowingSection: true,
      tipoLocacao: 'assinatura',
      showFeaturedOffers: false,
      recentCarouselTitle: 'Razões para alugar na Velz',
      showRecentCarouselImageBadges: false,
      simpleRecentCarouselCards: true,
      fixedRecentReasonsGrid: true
    }
  },
  {
    path: "seminovos",
    component: Home1Component,
    data: { title: 'Seminovos', seo: SEO.seminovos, heroAction: 'search' }
  },
  {
    path: '', loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardModule)
  },
  {
    path: 'catalog', loadChildren: () => import('./catalog/catalog.module').then(m => m.CatalogModule)
  },
  {
    path: 'account', loadChildren: () => import('./account/account.module').then(m => m.AccountModule)
  },
  {
    path: 'vendor', loadChildren: () => import('./vendor/vendor.module').then(m => m.VendorModule)
  },
  {
    path: 'pages', loadChildren: () => import('./extrapages/extrapages.module').then(m => m.ExtrapagesModule)
  },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class PagesRoutingModule { }
